export const regTitles = ['Sir','Ma\'am', 'Madam', 'Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Professor'];